import { lazy } from 'react';
import { useAuth } from '../context/AuthContext/AuthContext';
import PrivateWrapper from './PrivateWrapper/PrivateWrapper';
import SuspenseFallback from './SuspenseFallback';

const DashboardPage = lazy(() => import('../pages/DashboardPage/DashboardPage'));
const MapSearchPage = lazy(() => import('../pages/MapSearchPage/MapSearchPage'));

export default function RootRoute() {
    const { user, isAuthLoading } = useAuth();

    if (isAuthLoading) {
        return <SuspenseFallback />;
    }

    if (user) {
        return (
            <PrivateWrapper>
                <DashboardPage />
            </PrivateWrapper>
        );
    }

    return <MapSearchPage />;
}
